import { Header } from './components/Header'
import { AppDownloadBanner } from './components/AppDownloadBanner'
import { Hero } from './components/Hero'
import { WhyBimaUncle } from './components/WhyBimaUncle'
import { ProductsCovered } from './components/ProductsCovered'
import { FeatureShowcase } from './components/FeatureShowcase'
import { FuzzySearch } from './components/FuzzySearch'
import { PlatformParity } from './components/PlatformParity'
import { TesterSignup } from './components/TesterSignup'
import { Footer } from './components/Footer'
import { LegalPage } from './components/LegalPage'
import { SupportPage } from './components/SupportPage'
import { ResetPassword } from './components/ResetPassword'
import { Reveal } from './components/Reveal'
import type { LegalDoc } from './components/LegalModal'

/**
 * Tiny path-based router. The site is a single-page marketing app served
 * with an SPA fallback (public/_redirects sends every path to index.html),
 * so we read the pathname once at render and pick the view. No history
 * library needed — these routes are entered via external links (app-store
 * listings, the Supabase recovery email) and only navigate back to "/".
 */
function route():
  | { kind: 'home' }
  | { kind: 'legal'; doc: LegalDoc }
  | { kind: 'reset' }
  | { kind: 'support' } {
  const path = window.location.pathname.replace(/\/+$/, '').toLowerCase() || '/'

  if (path === '/support' || path === '/help' || path === '/contact') {
    return { kind: 'support' }
  }
  if (path === '/privacy' || path === '/privacy-policy') {
    return { kind: 'legal', doc: 'privacy' }
  }
  if (
    path === '/terms' ||
    path === '/terms-of-service' ||
    path === '/terms-and-conditions'
  ) {
    return { kind: 'legal', doc: 'terms' }
  }
  if (path === '/cookie-policy' || path === '/cookies' || path === '/cookie') {
    return { kind: 'legal', doc: 'cookies' }
  }
  if (path === '/reset-password' || path === '/auth/reset') {
    return { kind: 'reset' }
  }
  return { kind: 'home' }
}

export default function App() {
  const r = route()

  if (r.kind === 'legal') return <LegalPage doc={r.doc} />
  if (r.kind === 'support') return <SupportPage />
  if (r.kind === 'reset') return <ResetPassword />

  return (
    <div className="min-h-screen">
      <Header />
      <AppDownloadBanner />
      <main>
        <Hero />
        <Reveal><WhyBimaUncle /></Reveal>
        <Reveal><ProductsCovered /></Reveal>
        <Reveal><FeatureShowcase /></Reveal>
        <Reveal><FuzzySearch /></Reveal>
        <Reveal><PlatformParity /></Reveal>
        <Reveal><TesterSignup /></Reveal>
      </main>
      <Footer />
    </div>
  )
}
